
<mat-card class="filter settingHeader">
  <div class="name">
    Document Templates
  </div>
  <div class="quickAction">
    
     <mat-form-field appearance="fill">
      <mat-label>Select Category</mat-label>
      <mat-select (selectionChange)="onChangeCategory($event)" value="All">
        <mat-option value="All">All</mat-option>
        <mat-option value="Public">Public</mat-option>
        <mat-option value="Private">Private</mat-option>        
      </mat-select>
    </mat-form-field>
    
    <!-- <mat-form-field appearance="" >
      <mat-label>Search items in tags</mat-label>
      <input matInput type="text" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field> -->

  </div>
</mat-card>

<div class="documents">
  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <!-- <span class="moveicon"></span>      -->
      <span class="moveicon"></span>  
      <span class="fieldName">Template Name</span>    
      <span class="fieldName">Folder Name</span>   
      <span class="fieldName">Public/Private</span>      
      <span class="fieldName">Module</span>    
      <span class="fieldName">Type</span> 
      <span class="editField">Edit</span> 
      <span class="delete">Delete</span>
    </div>
    <div cdkDropList  (cdkDropListDropped)="dropTemplate($event)">
    <div class="example-box fieldRow" *ngFor="let temp of templateList" cdkDrag>
      <!-- <span class="moveicon"></span> -->
      <span class="moveicon">
        <mat-icon cdkDragHandle class="drag-icon" matTooltip="Drag to reorder" matTooltipPosition="above">
            drag_handle
         </mat-icon>
      </span>
      

      
      <mat-checkbox *ngIf="temp.isPublic==false" color="primary" [checked]= "temp.isDefault" class="checkbox" (change)="showOptions($event,temp)">        
      </mat-checkbox>      

      <span class="fieldName">{{temp.templateName}}</span>    
      <span class="fieldName">{{temp.folderName}}</span>    
      <span class="fieldName" *ngIf="temp.isPublic==true">Public</span>  
      <span class="fieldName" *ngIf="temp.isPublic==false">Private</span>  

      <span class="fieldName">{{temp.moduleName}}</span>
      <span class="fieldName">{{temp.typeName}}</span>

       <span class="editField">
        <button mat-icon-button class="editbtn" (click)="openDialogWithRef(myDialog,temp)">
          <mat-icon>edit</mat-icon>
        </button>
      </span>

      <span class="delete">
        <button mat-icon-button class="trash" (click)="deleteTemplate(temp)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </span>
    </div>
    </div>
    <!-- (click)="deleteTags(temp)" -->
    <!-- <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons [length]="paginatorTotalLength" 
    (page)="CallNextPrevPageData($event)">
     </mat-paginator> -->
   
  </mat-card>

  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>


<ng-template #myDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Edit Template Name
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Template Name</mat-label>
      <input matInput [required]="true"  placeholder="Edit template name" formControlName="templateName" [(ngModel)]="editType.templateName" />
      <mat-error
      *ngIf="formDialog.get('templateName').invalid &&
        (formDialog.get('templateName').dirty ||
        formDialog.get('templateName').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>    

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" 
  [disabled]="formDialog.invalid || !formDialog.dirty"   
  (click)="UpdateTemplateName()">
    Update
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>

<app-loader></app-loader>